import { render, staticRenderFns } from "./recClass.vue?vue&type=template&id=390a4859&"
import script from "./recClass.vue?vue&type=script&lang=js&"
export * from "./recClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports